import { useRuntimeActionLock } from '../contexts/RuntimeOperationProvider';

export default useRuntimeActionLock;